import { FC, useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useCategoryRelationOptions } from './useCategoryRelationOptions';
import { getSubCategoryTypeOneLetterCode } from '@atlas-frontend/sdk';

export interface SubCategoryTypeInputPreviewProps {
  isCombinedGroups: boolean;
  parentName: string;
  formDataIndex: number;
}

export const SubCategoryTypeInputPreview: FC<
  SubCategoryTypeInputPreviewProps
> = (props) => {
  const { isCombinedGroups, parentName, formDataIndex } = props;
  const subCategoryType = useWatch({
    name: `${parentName}.${formDataIndex}.subCategory`,
  });
  const options = useCategoryRelationOptions(isCombinedGroups);
  const selectedSubCategoryType = useMemo(
    () => options.find((o) => o.value === subCategoryType)?.type,
    [options, subCategoryType]
  );

  return getSubCategoryTypeOneLetterCode(selectedSubCategoryType);
};
